const ISSUE_LABELS = {
  INVALID_NODE_KEY: 'Identificador de nodo inválido',
  DUPLICATE_NODE_KEY: 'Nodo duplicado',
  UNKNOWN_NODE_TYPE: 'Tipo de nodo no reconocido',
  INVALID_NODE_CONFIG: 'Configuración inválida o incompleta',
  CROSS_VERSION_NODE: 'Nodo de otra versión',
  SOURCE_NODE_NOT_FOUND: 'Nodo de origen inexistente',
  TARGET_NODE_NOT_FOUND: 'Nodo de destino inexistente',
  CROSS_VERSION_EDGE: 'Conexión de otra versión',
  INVALID_SOURCE_PORT: 'Salida de conexión inválida',
  INVALID_TARGET_PORT: 'Entrada de conexión inválida',
  INCOMPATIBLE_PORT_TYPE: 'Tipos de datos incompatibles',
  DUPLICATE_EDGE: 'Conexión duplicada',
  MISSING_REQUIRED_INPUT: 'Falta una entrada obligatoria',
  INPUT_CARDINALITY_EXCEEDED: 'Demasiadas conexiones en una entrada',
  DUPLICATE_INPUT_ORDER: 'Orden de entrada duplicado',
  OUTPUT_NODE_REQUIRED: 'Falta una salida del modelo',
  DUPLICATE_OUTPUT_KEY: 'Nombre de resultado duplicado',
  GRAPH_CYCLE_DETECTED: 'Dependencia circular detectada',
  DEVICE_NOT_FOUND: 'Dispositivo inexistente',
  BASIC_PARAMETER_NOT_FOUND: 'Parámetro básico inexistente',
  LEGACY_CALCULATED_PARAMETER_NOT_FOUND: 'Parámetro calculado inexistente',
  PARAMETER_DEVICE_MISMATCH: 'El parámetro no pertenece al dispositivo',
  DISCONNECTED_NODE: 'Nodo sin conexiones',
  INVALID_PAYLOAD: 'Datos enviados inválidos',
};

const ISSUE_MESSAGES = {
  INVALID_NODE_CONFIG: 'Revisá los valores obligatorios y el formato de la configuración.',
  MISSING_REQUIRED_INPUT: 'Conectá el valor requerido antes de publicar el modelo.',
  INPUT_CARDINALITY_EXCEEDED: 'Eliminá las conexiones adicionales de esta entrada.',
  OUTPUT_NODE_REQUIRED: 'Agregá al menos un nodo de salida numérica.',
  GRAPH_CYCLE_DETECTED: 'Las conexiones forman un ciclo que debe corregirse antes de publicar.',
  DISCONNECTED_NODE: 'Este nodo todavía no participa en ninguna conexión.',
};

const issueLabel = issue => ISSUE_LABELS[issue.code] || 'Problema de validación';
const issueMessage = issue => ISSUE_MESSAGES[issue.code] || issue.message || 'Revisá la configuración indicada.';

const IssueList = ({ title, issues, kind, onSelectNode }) => <section className={`cm-validation-group is-${kind}`}>
  <h3>{title} <span>{issues.length}</span></h3>
  {!issues.length ? <p>Sin elementos.</p> : <ul>{issues.map((issue, index) => <li key={`${issue.code}-${issue.node_key || 'graph'}-${index}`}>
    <button type="button" disabled={!issue.node_key} onClick={() => issue.node_key && onSelectNode(issue.node_key)}>
      <strong>{issueLabel(issue)}</strong><span>{issueMessage(issue)}</span>{issue.node_key && <small>Seleccionar nodo</small>}
    </button>
  </li>)}</ul>}
</section>;

export default function ValidationPanel({ validation, onSelectNode }) {
  if (!validation) return <div className="cm-validation cm-validation-idle">
    <p>Revisá el modelo para ver errores y advertencias.</p>
  </div>;
  return <div className={`cm-validation ${validation.valid ? 'is-valid' : 'is-invalid'}`} aria-live="polite">
    <header><strong>{validation.valid ? 'Modelo válido' : 'Modelo incompleto o inválido'}</strong><span>Validación {validation.mode === 'structural' ? 'estructural' : 'completa'}</span></header>
    <div className="cm-validation-columns">
      <IssueList title="Errores" kind="error" issues={validation.errors || []} onSelectNode={onSelectNode} />
      <IssueList title="Advertencias" kind="warning" issues={validation.warnings || []} onSelectNode={onSelectNode} />
    </div>
  </div>;
}
